export const ActionTypes = {
    SET_GLOBAL_ID: "SET_GLOBAL_ID",
};